const Gidelines = (props :any) => {
  return (
    <div className='content-wrap'>
      <div className='title'>-GUIDELINES-</div>
      <div className='guideline-text'>
        <div className="category">
          <div className='sub'>切り抜き動画について</div>
          <p className='text'>
            {`■注意事項

            歌枠の切り抜きは原則NGです。（カラオケ音源の利用規約があるため）

            切り抜き元配信URL、チャンネルURLを概要欄に記載してください。

            悪意のある切り抜き方をしないでください。

            配信を編集を加えずにそのままアップロードすることはおやめください。`}
          </p>
        </div>
        <div className="category">
          <div className='sub'>ファンアートについて</div>
          <p>
            {`ファンアートはとてもうれしいです！🤍

            『#花波のはなたば』のついたものは、SNSやサムネイル等に使わせていただく場合があります。


            ■有償依頼ファンアートについて

            もし活動に使って良ければ、依頼する際に絵師様に以下をお願いしていただき、データを送っていただけると嬉しいです。

            ①サムネイル等への使用許諾
            ②イラストの透過データ(あるとサムネに非常に使いやすいです!)


            ■注意事項

            センシティブなものやグロテスクなもの等はハッシュタグをつけないでください。

            AIイラストの公開は禁止です。

            花波の姿・他の方が描かれたファンアート等をAIに学習させてインターネット上にアップロードする行為はおやめください。`}
          </p>
        </div>
        <div className="category">
          <div className='sub'>花波が投稿した画像について</div>
          <p>
            {`■注意事項

            SNSのアイコン等に使用しないでください。

            花波が使用していないSNSに無断で転載しないでください。（現在運用しているのはX、BlueSkyのみ）`}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Gidelines;